import React, { useEffect, useState } from "react";
import Tabla from "./Tabla";
import accesos_icon from "../../../assets/vw/svg/accesos.svg";
import Loading from "../../../components/Loading";
import Menu from "../../../components/Menu";
import Modal from "../../../components/Modal";
import NoInfoScreen from "../../../components/Screens/NoInfoScreen";

const AccesosPermanentes = (props) => {
  const [accesosPermanentes, setAccesosPermanentes] = useState([]);
  const [accesosPermanentesFiltrados, setAccesosPermanentesFiltrados] =
    useState([]);
  const [cargando, setCargando] = useState(true);
  const [searchInput, setSearchInput] = useState("");
  const [aplicaciones, setAplicaciones] = useState([]);
  const [modal, setModal] = useState({
    active: false,
    message: '',
    success: false
  }); 

  /* Un gancho useEffect que se llama cuando cambia el estado searchInput o accesosPermanentes. */
  useEffect(() => {
    Promise.all([
      fetch(process.env.REACT_APP_URL_DTO_BACK + "sesiones/permanentes", {
        method: "GET",
        headers: {
          Authorization: "Bearer " + props.servicio.getToken(),
          "Content-Type": "application/json",
        },
      }).then(async (res) => {
        let response = await res.json();
        if (!res.ok) {
          throw new Error(response.mensaje);
        }
        return response;
      }),
      fetch(process.env.REACT_APP_URL_DTO_BACK + "aplicacion?todos", {
        method: "GET",
        headers: {
          Authorization: "Bearer " + props.servicio.getToken(),
          "Content-Type": "application/json",
        },
      }).then(async (res) => {
        let response = await res.json();
        if (!res.ok) {
          throw new Error(response.mensaje);
        }
        return response;
      }),
    ])
      .then(([responseBodySesiones, responseBodyAplicaciones]) => {
        setAccesosPermanentes(responseBodySesiones.mensaje);
        setAplicaciones(responseBodyAplicaciones.mensaje);
        setCargando(false);
      })
      .catch((errorP) => {
        setCargando(false);
        setModal({
          active: true,
          message: errorP.message,
          success: false
        });
        console.error(errorP.stack || errorP);
      });
  }, [props.servicio]);

  /* Un gancho useEffect que se llama cuando cambia el estado searchInput o accesosPermanentes. */
  useEffect(() => {
    if (searchInput && searchInput !== "") {
      let accesosPermanentesFiltradas = accesosPermanentes.filter((item) => {
        return (
          item.nombre.toLowerCase().includes(searchInput.toLowerCase()) ||
          item.correo.toLowerCase().includes(searchInput.toLowerCase())
        );
      });
      setAccesosPermanentesFiltrados(accesosPermanentesFiltradas);
    } else {
      let accesosPermanentesFiltradas = [];
      setAccesosPermanentesFiltrados(accesosPermanentesFiltradas);
    }
  }, [searchInput, accesosPermanentes]);

  /**
   * Cuando cambie el valor de entrada, establezca el estado searchInput en el nuevo valor.
   * @param event - El objeto de evento es un evento de JavaScript que se envía a un elemento cuando
   * ocurre un evento en el elemento.
   */
  const handleChange = (event) => {
    setSearchInput(event.target.value);
  };

 

  return (
    <>
    <Menu/>
    <Modal modalInfo={modal} setMostrarModal={setModal} />
    {
      cargando && <Loading />
    }
    <div className={`navegacion`}>
    { accesosPermanentes.length > 0 && aplicaciones.length > 0 ?
     <>
        <div className=" posicionMenu">
          <ul className="d-flex flex-row px-0 my-0">
            <li
              className="opcion-ruta normal_width"
            >
              <div
                className={`nav-link active ps-0 active border_menu`}
              >
                <img
                  src={accesos_icon}
                  alt="accesos"
                  className="icono-menu me-3"
                />
                Accesos permanentes
              </div>
            </li>
            
          </ul>
        </div>
        <div className="row border_vw pt-4 ms-0 mx-0">
          <div className="col-12 p-0 contenedor-table">
            {accesosPermanentes.length >= 0 ? (
              <Tabla
                accesosPermanentes={
                  accesosPermanentesFiltrados &&
                  accesosPermanentesFiltrados.length
                    ? accesosPermanentesFiltrados
                    : accesosPermanentes
                }
                servicio={props.servicio}
                marca={props.marca}
                aplicaciones={aplicaciones}
                handleChange={handleChange}
              ></Tabla>
            ) : (
              <div></div>
            )}
          </div>
        </div>
      </> : (
          <>
            {
              !cargando && <NoInfoScreen />
            }
          </>
        )
    }
    </div>
    </>
  );
};

export default AccesosPermanentes;
